import React, { useState, useEffect } from 'react';
import {
  Divider, Input, Form, Collapse, Button,
} from 'antd';
import { PlusCircleTwoTone } from '@ant-design/icons';

const { TextArea } = Input;
const { Panel } = Collapse;

const SmsCampaign = (properties) => {
  const { form } = properties;
  const [variableCount, setVariableCount] = useState(0);

  useEffect(() => {
    if (variableCount) {
      const templateValue = form.getFieldValue('template_content');
      form.setFieldsValue({ template_content: `${templateValue}{{${variableCount}}}` });
    }
  }, [variableCount]);

  const handleAddVariable = () => {
    setVariableCount(variableCount + 1);
  };

  return (
    <>
      <Divider />
      <Collapse defaultActiveKey={['1']}>
        <Panel header="SMS Details" key={1}>
          <div>
            <Form.Item name="sms_template_name" label="SMS Template Name">
              <Input style={{ width: '300px' }} />
            </Form.Item>
            <Form.Item name="sms_template_id" label="Template Id">
              <Input style={{ width: '300px' }} />
            </Form.Item>
            <Form.Item name="sender_id" label="Sender Id">
              <Input style={{ width: '300px' }} />
            </Form.Item>
            <Form.Item name="purpose" label="Purpose">
              <Input style={{ width: '300px' }} />
            </Form.Item>
            <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
              <Button
                icon={<PlusCircleTwoTone />}
                onClick={handleAddVariable}
                type="link"
              >
                Add Variable
              </Button>
            </Form.Item>
            <Form.Item name="sms_template_content" label="SMS Template Content">
              <TextArea rows={8} maxLength={1000} />
            </Form.Item>
          </div>
        </Panel>
      </Collapse>
      <Divider />
    </>
  );
};

export default SmsCampaign;
